import { Component, OnInit, OnDestroy } from '@angular/core';
import {Router, ActivatedRoute, NavigationEnd} from '@angular/router';
import { environment } from '../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { AuthService } from "../auth.service";
import { UtilsService } from "../shared/shared.module";

import * as _ from "lodash";

declare let swal:any;

@Component({
  selector: 'login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})

export class LoginComponent {

  environment: any;
  errors = {};
  isLoading;
  haveForgotPwd: boolean = false;

  private _subscription;

  user  = {
    email: '',
    password: ''
  };

  forgotUser = {
    email: '',
  }

  constructor(
    private router: Router,
    private utilsService: UtilsService,
    private http: HttpClient,
    private authService: AuthService
  ) {
    this.isLoading = false;
    this._subscription = authService.loadingChange.subscribe((value) => {
      this.isLoading = value;
    });
  }

  ngOnInit() {
    this.environment = environment;
    this.router.events.subscribe((evt) => {
      if (!(evt instanceof NavigationEnd)) {
        return;
      }
      this.utilsService.scrollTop();
    });
  }

  ngOnDestroy() {
    this._subscription.unsubscribe();
  }

  valueChange(field) {
    this.errors = {};
  }

  changeHaveForgot(val) {
    this.haveForgotPwd = val;
  }

  submitForgotForm(form) {
    this.errors = {};
    if (form.invalid)
      return;

    let data = this.forgotUser;
    this.isLoading = true;
    this.http.post(environment.API_PATH + '/user/reset', data, {withCredentials: true})
	  .subscribe(response => {
      this.isLoading = false;
      this.utilsService.displayNotif("Un email vous sera envoyé pour definir votre nouveau mot de passe", "success");
    }, err => {
      this.isLoading = false;
      if (err.status === 404) {
        var details = err.error.error.details;
        if (details === 'Email is required')
          this.errors['forgotEmail']= "Ce champ doit être rempli";
        else if (details === 'User not found')
          this.errors['forgotEmail']= "Cette utilisateur n'exsite pas";
      } else {
        this.utilsService.displayNotif("Une erreur est survenue, merci de réessayer", "danger");
      }
    });
  }

  submitForm(form) {
    this.errors = {};
    if (form.invalid)
      return;

    let data = this.user;
    this.isLoading = true;
    this.http.post(environment.API_PATH + '/login', data, {withCredentials: true})
      .subscribe(response => {
        this.isLoading = false;
        this.authService.login(response);
      }, err => {
        this.isLoading = false;
        if (err.status === 401) {
          this.errors['email']= "Couple d'identifiants invalide";
        } else {
          var details = err.error.error.details;
          if (details === "Missing email")
            this.errors['email'] = "Ce champ doit être rempli";
          else if (details === "Missing password")
            this.errors['password'] = "Ce champ doit être rempli";
          else if (details === 'Incorrect username')
            this.errors['email'] = "Couple d'identifiants invalide";
          else if (details === 'Your account needs to be activated')
            this.errors['email'] = "Vous devez valider votre compte";
          else if (details === 'Your account can not authenticate here')
            this.errors['email'] = "Vous ne pouvez pas vous connecter ici";
          else
            this.utilsService.displayNotif("Une erreur est survenue, merci de réessayer", "danger");
        }
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/login/login.component.ts